// extracted by mini-css-extract-plugin
export default {"uri":"SnapURIs__uri-Jtcfw"};